export default "{\n    \"label\": \"Categorías de servicio\",\n    \"placeholderText\": \"Seleccione categorías\"\n}\n"